/**
 * After a new version is deployed, a page opened before it still asks for the old code files (they are loaded only when
 * needed, e.g. the PDF reader) — they are gone, and the browser says "Failed to fetch dynamically imported module".
 * JF 2026-10-14: all 7 styles of a batch failed with it. Recognised here; the page asks to refresh instead.
 */
import { useStore } from "../store.ts";

const STALE = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;
export const isStale = (e: unknown) => STALE.test(e instanceof Error ? e.message : String(e ?? ""));
export const STALE_MSG = "系统刚更新过，请刷新页面（Ctrl+F5）后再试。/ The app was just updated — please refresh the page (Ctrl+F5) and try again.";
/** show the "please refresh" bar; true when it was such an error */
export function flagStale(e: unknown): boolean {
  if (!isStale(e)) return false;
  useStore.getState().setStale(true);
  return true;
}
